import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import {
  EMAIL_PROFILE_NAVIGATION_NEXT_ICON_PROPS,
  EMAIL_PROFILE_NAVIGATION_PREVIOUS_ICON_PROPS,
} from '../../../Email.constants'

import {
  QA_NAME_EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_NEXT,
  QA_NAME_EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_PREVIOUS,
} from './EmailProfileUnavailableNavigation.constants'

function EmailProfileUnavailableNavigation({
  navigation: { handleNext, handlePrevious, hasNext, hasPrevious, isLoading },
}) {
  const { t } = useTranslation()

  function handleClickPrevious() {
    handlePrevious()
  }

  function handleClickNext() {
    handleNext()
  }

  return (
    <>
      <Button.White
        isGrey
        beforeIconProps={EMAIL_PROFILE_NAVIGATION_PREVIOUS_ICON_PROPS}
        disabled={isLoading || !hasPrevious}
        qaName={QA_NAME_EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_PREVIOUS}
        text={t('EmailProfile.UnavailablePreviousEmailButtonKey')}
        onClick={handleClickPrevious}
      />
      <Button.White
        isGrey
        afterIconProps={EMAIL_PROFILE_NAVIGATION_NEXT_ICON_PROPS}
        disabled={isLoading || !hasNext}
        qaName={QA_NAME_EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_NEXT}
        text={t('EmailProfile.UnavailableNextEmailButtonKey')}
        onClick={handleClickNext}
      />
    </>
  )
}

export default EmailProfileUnavailableNavigation
